// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

/**
 * Digital Twin Service
 * API calls for datacenter digital-twin graph data (entities, relationships, state).
 * Calls the BFF which authenticates to APIM with its own client credentials.
 */

import { get } from './api';
import { ENDPOINTS } from '../utils/constants';
import type { DatacenterDetailsResponse, TwinModelResponse } from '../types';

interface DetailsParams {
  entityType?: string;
  relationshipType?: string;
  include?: string;
  limit?: number;
  cursor?: string;
}

/**
 * Get datacenter site details (normalized subgraph of entities + relationships).
 */
export const getDatacenterDetails = async (
  siteId: string,
  params: DetailsParams = {}
): Promise<DatacenterDetailsResponse> => {
  const queryParams = new URLSearchParams();
  if (params.include !== undefined) queryParams.append('include', params.include);
  if (params.entityType) queryParams.append('entity_type', params.entityType);
  if (params.relationshipType) queryParams.append('relationship_type', params.relationshipType);
  if (params.limit !== undefined) queryParams.append('limit', String(params.limit));
  if (params.cursor) queryParams.append('cursor', params.cursor);

  const base = ENDPOINTS.DIGITAL_TWIN_DETAILS(siteId);
  const url = queryParams.toString() ? `${base}?${queryParams}` : base;
  return get<DatacenterDetailsResponse>(url);
};

/**
 * Get the datacenter twin data-model schema (entity types, measurements, relationships).
 */
export const getTwinModel = async (): Promise<TwinModelResponse> => {
  return get<TwinModelResponse>(ENDPOINTS.DIGITAL_TWIN_MODEL);
};
